import type { GameRecord } from "@/app/constants.mjs";
import type { AnyGameDefinition } from "@/app/game-definition.mjs";
import gamesList, { deriveGamesPropMap } from "@/app/games.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

export const GAME_OVERLAY_DB_KEYS = new SymbolMap({
  ...deriveGamesPropMap("overlaySettingsKey"),
});

interface GameLibraryImages {
  hero?: string;
  banner?: string;
  keyart: string;
  wordmark?: string;
}

export const GAME_LIBRARY_IMAGES = new SymbolMap<GameRecord<GameLibraryImages>>(
  gamesList.reduce((obj, gameDef) => {
    const { gameSymbol, imageHero, imageBanner, imageKeyart, imageWordmark } =
      gameDef as AnyGameDefinition;
    obj[gameSymbol] = {
      hero: imageHero,
      banner: imageBanner,
      keyart: imageKeyart,
      wordmark: imageWordmark,
    };
    return obj;
  }, {}),
);
